import * as React from "react";
import { Badge } from "@volca/ui/components/ui/badge";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface SelfSignupBadgeProps {
  className?: string;
}

export const SelfSignupBadge: React.FC<SelfSignupBadgeProps> = ({
  className,
}) => (
  <Badge variant="secondary" className={cn("gap-2", className)}>
    <Text variant="caption">Self sign-up</Text>
  </Badge>
);

SelfSignupBadge.displayName = "SelfSignupBadge";
